import { Col, Empty, Row } from 'antd';
import { FC, memo, useEffect, useState } from 'react';
import { PlanRow, fetchPlans } from 'services/api/profile';

import PlanItem from '../PlanItem';

const Plans: FC = () => {
  const [results, setResults] = useState<PlanRow[]>([]);

  useEffect(() => {
    fetchPlans()
      .then(setResults)
      .catch(() => setResults([]));
  }, []);

  return (
    <div>
      {results.length ? (
        <Row gutter={[16, 16]} wrap>
          {results.map(item => (
            <Col sm={8} key={`plan-item-${item.id}`}>
              <PlanItem
                id={item.id}
                name={item.name}
                type={item.type}
                duration={item.duration}
                description={item.description}
                price={item.price}
                features={item.features}
              />
            </Col>
          ))}
        </Row>
      ) : (
        <Row justify="center">
          <Empty />
        </Row>
      )}
    </div>
  );
};

export default memo(Plans);
